<template>

    <nav class="navbar tool-navbar navbar-light" :class="{ 'with-faq' : project.allow_faq }">

        <div class="collapse navbar-collapse side-menu-toggle" id="side-tool-menu">

            <div>

                <span class="close-popup" data-toggle="collapse" data-target="#side-tool-menu" aria-controls="side-tool-menu" ><i class="fas fa-times"></i></span>

                <ul class="navbar-nav">

                    <li class="nav-item">
                        <a :title="language.welcome" class="nav-link" v-on:click="toggleWelcomeWindow('link')">
                            <svg class="svg-icon hand"><use xlink:href="#hand" /></svg>
                            {{ language.welcome }}
                        </a>
                    </li>

                    <li v-if="project.welcome_mode !== 'END'" class="nav-item">
                        <a title="Give comments" class="nav-link" :href="addurl">
                            <svg class="svg-icon pencil"><use xlink:href="#pencil" /></svg>
                            {{ language.give_comment }} <span v-if="addopinion && dataStore.collectedAnswers.length" class="collected-answers side">{{ language.not_submitted_comments.replacePlaceholders({ amount: dataStore.collectedAnswers.length}) }}</span>
                        </a>
                    </li>

                    <li v-if="project.welcome_mode !== 'END'" class="nav-item">
                        <a :title="language.view_comments" class="nav-link" :href="geturl">
                            <svg class="svg-icon marker"><use xlink:href="#marker" /></svg>
                            {{ language.view_comments }}
                        </a>
                    </li>

                    <li v-if="project.allow_faq" class="nav-item">
                        <a :title="language.faq" class="nav-link" :href="faqLink">
                            <svg class="svg-icon faq"><use xlink:href="#faq" /></svg>
                            {{ language.faq }}
                        </a>
                    </li>

                    <li v-if="project.link && project.link.length" class="nav-item">
                        <a :title="language.more_information" class="nav-link" target="_blank" :href="project.link">
                            <svg class="svg-icon information"><use xlink:href="#information" /></svg>
                            {{ language.more_information }}
                        </a>
                    </li>

                    <li v-if="project.map_link && project.map_link.length" class="nav-item">
                        <a :title="language.find_place" class="nav-link" target="_blank" :href="project.map_link">
                            <svg class="svg-icon find"><use xlink:href="#find" /></svg>
                            {{ language.find_place }}
                        </a>
                    </li>

                    <li class="nav-item">
                        <a :title="language.share_dialogue" class="nav-link" v-on:click="copyProjectLink">
                            <svg class="svg-icon share"><use xlink:href="#share" /></svg>
                            {{ language.share_dialogue }}
                        </a>
                        <p class="copy-text" v-if="copytext">{{copytext}}</p>
                    </li>

                    <li class="nav-item">
                        <a :title="language.about" class="nav-link" target="_blank" :href="mainUrl">
                            <svg class="svg-icon about"><use xlink:href="#about" /></svg>
                            {{ language.about }}
                        </a>
                    </li>

                </ul>

            </div>

        </div>

        <div class="top">

            <div class="project-name">

                <a title="Dialognamn" class="read-more" :class="{ 'big-title' : showTitle && bigTitle }" v-on:click.prevent="() => true" href="#" data-toggle="collapse" data-target="#side-tool-menu" aria-controls="side-tool-menu" aria-expanded="false" aria-label="Toggle side menu tool">
                    <span v-if="showTitle && !bigTitle">{{ project.title }}</span>
                    <span v-if="showTitle && bigTitle" v-html="project.title.replace(/\s/,' <br>')"></span>
                    <img :alt="project.title" v-if="project.logo_instead_name" class="logo-top mobile logo-instead" :class="project.slug" :src="`/images/projects/project-logo/${project.logo_instead_name}`" />
                </a>

            </div>

        </div>

        <ul v-if="project.project_state && project.project_state.filter(state => state.name.length > 0).length" v-bind:class="classObjectProjectState" class="project-states">
            <li v-bind:class="classObjectSingleState(state.id)" v-for="(state) in project.project_state.filter(state => state.name.length > 0)" :key="`state-${state.id}`">
                <a :title="'Dialogskede: ' + state.name" target="_blank" v-if="state.link !== ''" :href="state.link">{{ state.name }}</a>
                <span :title="'Dialogskede: ' + state.name" v-else>{{ state.name }}</span>
            </li>
        </ul>

        <faq v-if="project.allow_faq" :project="project" />

        <div class="customer" :class="{ 'big-title' : bigCustomer }" v-if="!project.allow_faq">
            <img v-if="project.logotype" :alt="project.title" class="logo-top desktop" :class="project.slug" :src="`/images/projects/project-logo/${project.logotype}`" />
            <span v-if="project.selected_customer && !project.logotype && !bigCustomer" v-html="project.selected_customer"></span>
            <span v-if="project.selected_customer && !project.logotype && bigCustomer" v-html="project.selected_customer.replace(/\s/,' <br>')"></span>
        </div>

        <fragment v-else>

            <a class="customer" :class="{ 'big-title' : bigCustomer }" title="faq" v-if="project.logotype || project.selected_customer" :href="faqLink">
                <img v-if="project.logotype" :alt="project.title" class="logo-top desktop" :class="project.slug" :src="`/images/projects/project-logo/${project.logotype}`" />
                <span v-if="project.selected_customer && !project.logotype && bigCustomer" v-html="project.selected_customer.replace(/\s/,' <br>')"></span>
                <span v-if="project.selected_customer && !project.logotype && !bigCustomer" v-html="project.selected_customer"></span>

            </a>

        </fragment>

    </nav>

</template>

<script>


import Faq from './../Faq'

import dataStore from '../../store'

import { Fragment } from 'vue-fragment'

export default {

    inject: [ 'language' ],

    data() {
        return {
            dataStore,
            copytext : ''
        };
    },

    components : {
        Faq,
        Fragment
    },

    props: {
        project: Object,
        geturl : String,
        addurl : String,
        addopinion: Boolean,
    },

    computed: {

        sessionName: function() {
            return `welcome-info-show-${this.project.slug}`
        },

        showTitle: function() {
            return this.project.logo_instead_name === '' || this.project.logo_instead_name === null
        },

        bigTitle: function() {
            return this.project.title.length > 17
        },

        bigCustomer: function() {
            return this.project.selected_customer.length > 17
        },

        classObjectProjectState: function() {
            if(!this.project.project_state) return ''

            return {
                single : this.project.project_state.length === 1,
                two : this.project.project_state.length === 2,
                multi : this.project.project_state.length > 2,
            }
        },

        mainUrl: function() {
            return window.location.origin
        },

        faqLink: function() {
            return this.mainUrl + '/' + this.project.slug + '/faq'
        }

    },


    methods: {

        classObjectSingleState: function(id) {
            return {
                active : this.project.current_project_state === id,
            }
        },

        copyProjectLink: function() {
            this.copyStringToClipboard(this.geturl);
        },

        toggleWelcomeWindow: function (link = null) {

            document.querySelector('#side-tool-menu .close-popup').click()

            sessionStorage.removeItem( this.sessionName )

            this.dataStore.showWolcomeWindow = ! this.dataStore.showWolcomeWindow;

            this.dataStore.addLink = link === 'link' ? true : false
        },


        copyStringToClipboard: function (str) {

            try {
                // Create new element
                var el = document.createElement('textarea');
                // Set value (string to be copied)
                el.value = str;
                // Set non-editable to avoid focus and move outside of view
                el.setAttribute('readonly', '');
                el.style = {position: 'absolute', left: '-9999px'};
                document.body.appendChild(el);
                // Select text inside element
                el.select();
                // Copy text to clipboard
                document.execCommand('copy');
                // Remove temporary element
                document.body.removeChild(el);

                this.copytext = this.language.link_copied;

            } catch (error) {
                this.copytext = this.language.something_went_wrong;
            }

            setTimeout(() => { this.copytext = '' }, 3000);

        }

    }


};

</script>

